import React, { Component } from "react";
import { withRouter } from "react-router";
import { withStyles } from "material-ui/styles";
import Header from "./header/Header";
import Sidebar from "./sidebar/Sidebar";
import MainContainer from "../controls/MainContainer";
import Routes from "./Routes";

const styles = theme => ({
  root: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "calc(100vh - 1px)",
    minWidth: 0,
    minHeight: 0,
    overflow: "hidden",
    boxSizing: "border-box",
    borderBottom: "1px solid #e0e0e0"
  }
});

class Home extends Component {
  state = {
    mobileOpen: false
  };

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  render() {
    const { classes } = this.props;
    const { mobileOpen } = this.state;

    const shouldRenderMobileMenu =
      this.props.history.location.pathname === "/sale";

    return (
      <div className={classes.root}>
        <Header
          shouldRenderMobileMenu={shouldRenderMobileMenu}
          handleDrawerToggle={this.handleDrawerToggle}
        />

        <Sidebar
          mobileOpen={mobileOpen}
          handleDrawerToggle={this.handleDrawerToggle}
        />

        <MainContainer shouldRenderMobileMenu={shouldRenderMobileMenu}>
          <Routes />
        </MainContainer>
      </div>
    );
  }
}

const component = withStyles(styles, { withTheme: true })(Home);

export default withRouter(component);
